// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { JacketType } from './deal.interfaces';

export interface Lead {
    leadId: number;
    leadStatus: LeadStatus;
    leadStatusId: number;
    leadScreenStatus: string;
    dealerId: number;
    dealershipName: string;
    providerName: string;
    oemDealerId: number;
    stellantisLeadId: string; //to delete: name to be deprecated. 03/25/24
    oemLeadId: string;
    connectLeadId: string;
    leadRequestDate: string;
    ddjReceiveDate: string;
    dispositionId: number;
    dispositionCreateDate: string;
    disposition: string;
    dispositionDescription: string;
    dispositionSentDate: string;
    connectDispositionResponse: string;
    needsToSendDisposition: boolean;
    // Buyer
    buyerFirstName: string;
    buyerLastName: string;
    buyerEmail: string;
    buyerPhone: string;
    buyerStreet: string;
    buyerCity: string;
    buyerRegion: string;
    buyerPostalCode: string;
    buyerLastUpdateBy: number;
    buyerLastUpdateName: string;
    buyerLastUpdateDate: string;
    // Sales Person
    salesPersonFirstName: string;
    salesPersonLastName: string;
    salesPersonEmail: string;
    salesPersonPhone: string;
    // Vehicle
    price: string;
    status: string;
    vin: string;
    stockNumber: string;
    year: number;
    make: string;
    model: string;
    trim: string;
    bodyStyle: string;
    interest: string;
    adfXml: string;
    leadCreateDate: string;
    leadLastUpdateDate: string;
    lastRawLeadId: number;
    leadSource: string;

    leadNotes: string;
    leadNotesLastUpdateBy: number;
    leadNotesLastUpdateName: string;
    leadNotesLastUpdateDate: string;

    // deal
    dealId: number;
    dealJacketTypeId: JacketType;
    dealStatusId: string;
    dealStatus: string;
    vehicleLastUpdateBy: number;
    vehicleLastUpdateName: string;
    vehicleLastUpdateDate: string;
    // Vehicle Image Handling
    image: string;
    images: string;
    // Trade-In
    hasTradeIn: boolean;
    tradeInVin: string;
    tradeInStockNumber: string;
    tradeInYear: string;
    tradeInMake: string;
    tradeInModel: string;
    tradeInTrim: string;
    tradeInBodyStyle: string;
    tradeInValue: string;
    tradeInPayoff: string;
    tradeInLastUpdateBy: number;
    tradeInLastUpdateName: string;
    tradeInLastUpdateDate: string;
    // Payment
    type: string;
    downPayment: string;
    estimatedMonthlyPayment: string;
    msrp: string;
    totalIncentives: string;
    dealerDiscount: string;
    adjustedCapitalizedCosts: string;
    annualMileage: string;
    terms: string;
    incentivePrograms: string;
    dueAtSigning: string;
    taxes: string;
    fees: string;
    paymentLastUpdateBy: number;
    paymentLastUpdateName: string;
    paymentLastUpdateDate: string;
}

export enum LeadStatus {
    Open = 1,
    Completed = 2,
    Archived = 3,
    Deleted = 4,
}
